module.exports = __webpack_public_path__ + "static/media/everyday_digital_cropped.5ecb1771.webp";